module.exports = __webpack_public_path__ + "img/logo.3ad4b6db.png";